<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.tg_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.tg_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.tg_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="2">
              <b-row>
                <b-col md="12">
                  <el-form-item :label="aLang.tg_avatar" prop="avatar_id" class="mb-3">
                    <el-upload
                      action
                      :auto-upload="false"
                      list-type="picture-card"
                      :limit="mData.fileUploadOption.AnhDaiDien.limit"
                      :accept="mData.fileUploadOption.AnhDaiDien.accept"
                      :on-change="fn_uploadChangeAnhDaiDien"
                      :on-preview="fn_uploadPreviewAnhDaiDien"
                      :on-remove="fn_uploadRemoveAnhDaiDien"
                      :on-exceed="fn_uploadExceedAnhDaiDien"
                      :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                      :disabled="mData.viewMode == 'detail'"
                      :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog
                      :close-on-click-modal="true"
                      :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                      width="60%"
                      top="51px"
                      title="Chi tiết"
                    >
                      <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                    </el-dialog>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="10">
              <b-row>
                <b-col md="4">
                  <el-form-item :label="aLang.tg_fullname" prop="ho_ten.ho_ten">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.ho_ten.ho_ten"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item :label="aLang.tg_bod" prop="ngay_sinh.ngay_sinh">
                    <el-date-picker
                      type="datetime"
                      v-model="mData.dataForm.ngay_sinh.ngay_sinh"
                      :format="aElement.datepicker.formatDate"
                      :valueFormat="aElement.datepicker.valueFormat"
                      :disabled="mData.viewMode == 'detail'"
                      :placeholder="aElement.datepicker.placeholderDate"
                    >clearable</el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item :label="aLang.tg_gender" prop="gioi_tinh">
                    <el-select
                      v-model="mData.dataForm.gioi_tinh"
                      :placeholder="aLang.c_select"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listGioiTinh"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <el-form-item :label="aLang.tg_nationality" prop="quoc_tich.ten_quoc_tich">
                    <el-input
                      v-model="mData.dataForm.quoc_tich.ten_quoc_tich"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item :label="aLang.tg_email" prop="email">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.email"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item :label="aLang.tg_phone" prop="dien_thoai">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.dien_thoai"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <el-form-item :label="aLang.tg_address" prop="dia_chi.dia_chi">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.dia_chi.dia_chi"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-tabs card pills vertical v-model="tabIndex[1]" nav-wrapper-class="w-200">
                <b-tab active>
                  <template slot="title">{{aLang.tg_card}}</template>
                  <b-row>
                    <b-col md="6">
                      <el-form-item :label="aLang.tg_card_number" prop="the_hdv.so_the">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.the_hdv.so_the"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>

                    <b-col md="6">
                      <el-form-item :label="aLang.tg_card_status" prop="the_hdv.trang_thai_the">
                        <el-select
                          v-model="mData.dataForm.the_hdv.trang_thai_the"
                          :placeholder="aLang.c_select"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTrangThaiTheHDV"
                            :key="item.code"
                            :label="item.text"
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>

                    <b-col md="6">
                      <el-form-item :label="aLang.tg_card_type" prop="the_hdv.loai_the">
                        <el-select
                          v-model="mData.dataForm.the_hdv.loai_the"
                          :placeholder="aLang.c_select"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listLoaiTheHDV"
                            :key="item.code"
                            :label="item.text"
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>

                    <b-col md="6">
                      <el-form-item :label="aLang.tg_issued_by" prop="the_hdv.noi_cap">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.the_hdv.noi_cap"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item :label="aLang.tg_date_range" prop="the_hdv.ngay_cap">
                        <el-date-picker
                          type="datetime"
                          v-model="mData.dataForm.the_hdv.ngay_cap"
                          :format="aElement.datepicker.formatDate"
                          :valueFormat="aElement.datepicker.valueFormat"
                          :disabled="mData.viewMode == 'detail'"
                          :placeholder="aElement.datepicker.placeholderDatetime"
                        >clearable</el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item :label="aLang.tg_expiration_date" prop="the_hdv.het_han">
                        <el-date-picker
                          type="datetime"
                          v-model="mData.dataForm.the_hdv.het_han"
                          :format="aElement.datepicker.formatDate"
                          :valueFormat="aElement.datepicker.valueFormat"
                          :disabled="mData.viewMode == 'detail'"
                          :placeholder="aElement.datepicker.placeholderDatetime"
                        >clearable</el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab>
                  <template slot="title">{{aLang.tg_papers}}</template>
                  <b-row>
                    <b-col md="12">
                      <el-button
                        type="info"
                        plain
                        @click="fn_openModalGiayTo('create')"
                        v-if="mData.viewMode != 'detail'"
                      >{{aLang.tg_add_papers}}</el-button>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <div class="col-md-12">
                      <el-table
                        :data="mData.dataForm.giay_to"
                        border
                        max-height="440"
                        style="width: 100%; display: grid;"
                      >
                        <el-table-column prop="loai_giay_to" label="Loại giấy tờ" width="150"></el-table-column>
                        <el-table-column
                          prop="so_giay_to"
                          :label="aLang.tg_number_of_papers"
                          width="auto"
                          min-width="150"
                          align="center"
                        ></el-table-column>
                        <el-table-column prop="noi_cap" :label="aLang.tg_issued_by" width="150"></el-table-column>
                        <el-table-column
                          prop="ngay_cap"
                          :label="aLang.tg_date_range"
                          :formatter="fn_formatterDate"
                          width="150"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          prop="ngay_het_han"
                          :label="aLang.tg_expiration_date"
                          :formatter="fn_formatterDate"
                          width="150"
                          align="center"
                        ></el-table-column>

                        <el-table-column
                          :label="aLang.c_action"
                          align="center"
                          width="200px"
                          v-if="mData.viewMode != 'detail'"
                        >
                          <template slot-scope="scope">
                            <el-button
                              size="mini"
                              @click="fn_openModalGiayto('update',scope.$index, scope.row)"
                              v-b-tooltip.hover
                              :title="aLang.c_update"
                            >
                              <i class="icon-pencil icons"></i>
                            </el-button>
                            <el-button
                              size="mini"
                              @click="fn_handleGioiTo('delete',scope.$index, scope.row)"
                              v-b-tooltip.hover
                              :title="aLang.c_delete"
                            >
                              <i class="icon-trash icons"></i>
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </b-row>
                </b-tab>
                <b-tab>
                  <template slot="title">{{aLang.tg_more_information}}</template>
                  <b-row>
                    <b-col md="6">
                      <el-form-item :label="aLang.tg_foreign_language" prop="ngoai_ngu">
                        <el-select
                          v-model="mData.dataForm.ngoai_ngu"
                          :placeholder="aLang.c_select"
                          :disabled="mData.viewMode == 'detail'"
                          multiple
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listNgoaiNgu"
                            :key="item.id"
                            :label="item.name.vi"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item :label="aLang.tg_forte" prop="so_truong">
                        <el-select
                          v-model="mData.dataForm.so_truong"
                          :placeholder="aLang.c_select"
                          :disabled="mData.viewMode == 'detail'"
                          multiple
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listSoTruong"
                            :key="item.id"
                            :label="item.name.vi"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item :label="aLang.tg_achievements" prop="thanh_tich">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.thanh_tich"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item :label="aLang.tg_number_of_guided_tours" prop="tong_so_tour">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.tong_so_tour"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>

                    <b-col md="6">
                      <el-form-item :label="aLang.tg_practice_history" prop="lich_su_hanh_nghe">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.lich_su_hanh_nghe"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item :label="aLang.tg_number_of_years_of_practice" prop="so_nam_hanh_nghe">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.so_nam_hanh_nghe"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>

              <!-- end tab -->
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>   
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
// import ProvinceApi from "../../../moduleApi/ProvinceApi";
import ExtensionService from "../../../service/ExtensionService";
import HuongDanVienModel from "./HuongDanVienModel";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
// import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";
import TourApi from "../../../moduleApi/TourApi";
import SoTruongApi from "../../../moduleApi/SoTruongApi";
import NgoaiNguApi from "../../../moduleApi/NgoaiNguApi";
// import QuocTichApi from "../../../moduleApi/QuocTichApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      tabIndex: [0, 0],
      mData: {
        viewMode: "create",
        moduleName: "HuongDanVien",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          listCongTyLuHanh: [],
          listTour: [],
          listLoaiGiayTo: DataService.loaiGiayTo,
          listGioiTinh: DataService.gioiTinh,
          listSoTruong: [],
          listNgoaiNgu: [],
          listLoaiTheHDV: DataService.loaiTheHDV,
          listTrangThaiTheHDV: DataService.trangThaiTheHDV,
          listLoaiDinhDang: DataService.loaiDinhDang,
          // listQuocTich:[],
          GiayTo: {
            viewMode: "create",
            indexModal: undefined
          }
        },
        dataForm: MethodService.copyObject(HuongDanVienModel.dataForm),
        validForm: HuongDanVienModel.validForm,
        dataFormGiayTo: MethodService.copyObject(
          HuongDanVienModel.dataFormOther.giay_to
        ),
        validFormGiayTo: HuongDanVienModel.validFormOther.giay_to,

        dialog: {
          GiayTo: false
        },
        fileUploadOption: {
          AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          }
        }
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await HuongDanVienApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await HuongDanVienApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_resetFormGiayTo() {
      this.$refs["myFormGiayTo"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await HuongDanVienApi.findByIdAllField(id);     
      let resNew = MethodService.checkDifferentObject(MethodService.copyObject(HuongDanVienModel.dataForm), res.result);
      // console.log(resNew);
      resNew.ngay_sinh.ngay_sinh = new Date(
        resNew.ngay_sinh.nam,
        resNew.ngay_sinh.thang - 1,
        resNew.ngay_sinh.ngay
      ).toUTCString();

      let resTongSoTour = await TourApi.getTourCountByTourGuideIds(
        resNew.id
      );
      let itemSoTour = resTongSoTour.result.find(element => {
        return element.id == resNew.id;
      });
      if (itemSoTour) {
        resNew.tong_so_tour = itemSoTour.count;
      }

      if (
        resNew.the_hdv.het_han == undefined ||
        resNew.the_hdv.het_han == null
      ) {
        resNew.result.the_hdv.trang_thai_the = "not_active";
      } else {
        if (new Date() > new Date(resNew.the_hdv.het_han)) {
          resNew.the_hdv.trang_thai_the = "expired";
        } else {
          resNew.the_hdv.trang_thai_the = "active";
        }
      }

      if (resNew.the_hdv.ngay_cap) {
        var ngayHienTai = new Date();
        var ngayCap = new Date(resNew.the_hdv.ngay_cap);
        resNew.so_nam_hanh_nghe =
          ngayHienTai.getFullYear() - ngayCap.getFullYear();
        if (resNew.so_nam_hanh_nghe<1){
          resNew.so_nam_hanh_nghe="Dưới 1 năm";
        }
      }

      this.mData.dataForm = resNew;
      
      if (this.mData.dataForm.avatar_id) {
        let data = {
          id: this.mData.dataForm.avatar_id,
          name: this.mData.dataForm.avatar_id,
          url:
            ExtensionService.urlImg +
            this.mData.dataForm.avatar_id
        };
        this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
      }
    },
    async fn_initDataDefault() {
      let reqSoTruongApi = SoTruongApi.list({ limit: 1000 });
      let reqNgoaiNguApi = NgoaiNguApi.list({ limit: 1000 });
      let resSoTruongApi = await reqSoTruongApi;
      let resNgoaiNguApi = await reqNgoaiNguApi;
      this.mData.dataDefault.listSoTruong = resSoTruongApi.result;
      this.mData.dataDefault.listNgoaiNgu = resNgoaiNguApi.result;
    },

    // giấy tờ
    fn_handleGiayTo(type, index) {
      if (type == "create") {
        this.$refs["myFormGiayTo"].validate(async valid => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormGiayTo);
            this.mData.dataForm.hanh_trinh.push(item);
            this.fn_resetFormGiayTo();
            this.mData.dialog.GiayTo = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "update") {
        this.$refs["myFormGiayTo"].validate(async valid => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormGiayTo);
            this.mData.dataForm.hanh_trinh[
              this.mData.dataDefault.GiayTo.indexModal
            ] = item;
            this.fn_resetFormGiayTo();
            this.mData.dialog.GiayTo = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.mData.dataForm.hanh_trinh.splice(index, 1);
          })
          .catch(() => {});
      }
    },
    fn_openModalGiayTo(type, id) {
      this.mData.dialog.GiayTo = true;
      if (type == "create") {
        this.mData.dataDefault.GiayTo.indexModal = undefined;
        this.mData.dataDefault.GiayTo.viewMode = type;
        this.mData.dataFormGiayTo = MethodService.copyObject(
          HuongDanVienModel.dataFormOther.giay_to
        );
      } else {
        this.mData.dataDefault.GiayTo.indexModal = id;
        this.mData.dataDefault.GiayTo.viewMode = type;
        this.mData.dataFormGiayTo = MethodService.copyObject(
          this.mData.dataForm.giay_to[id]
        );
      }
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.anh.anh_dai_dien = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "huongDanVien")
        .then(res => {
          this.mData.dataForm.anh.anh_dai_dien = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    }
  },

  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>